import React from "react";
import { Link } from "react-router-dom";
import { SERVICES } from "../../data/site";
import SectionTitle from "./SectionTitle";

const ServiceCard = ({ service }) => (
  <Link
    to={`/services/${service.slug}`}
    className="group flex flex-col overflow-hidden border border-[#B79A68]/25 bg-[#fffdf8] shadow-[0_8px_32px_-12px_rgba(32,50,46,0.18)] transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_18px_40px_-12px_rgba(183,154,104,0.35)] rounded-sm"
  >
    {/* Image */}
    <div className="relative h-[200px] sm:h-[220px] md:h-[240px] overflow-hidden flex-shrink-0">
      <img
        src={service.image}
        alt={service.name}
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#20322E]/40 to-transparent" />
      {service.category && (
        <span className="absolute top-3 left-3 inline-flex items-center rounded-full border border-white/30 bg-[#20322E]/60 px-3 py-1 text-[10px] font-cinzel uppercase tracking-[0.28em] text-white/90 backdrop-blur-sm">
          {service.category}
        </span>
      )}
    </div>

    {/* Text */}
    <div className="flex flex-col flex-1 p-5 md:p-6">
      <h3 className="font-cinzel text-base sm:text-lg md:text-xl leading-snug text-[#20322E]">
        {service.name}
      </h3>
      <div className="mt-auto pt-5 flex items-center gap-3 text-[#B79A68]">
        <span className="h-px w-8 bg-[#B79A68]" />
        <span className="text-[10px] uppercase tracking-[0.32em] transition-all duration-300 group-hover:tracking-[0.42em]">
          Explore Service
        </span>
      </div>
    </div>
  </Link>
);

const DentalServicesSection = () => {
  return (
    <section id="dental-services" className="relative bg-[#FBF8F1] py-14 md:py-20 lg:py-24 border-t border-[#B79A68]/15">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <SectionTitle script="" title="Our Dental Services" subtitle="" align="center" />

          {/* <h2 className="font-cinzel text-2xl md:text-4xl gold-gradient-text tracking-[0.2em] -mt-2">
            DENTAL SERVICES
          </h2> */}
          <div className="flex items-center justify-center gap-3 my-5">
            <span className="h-px w-12 bg-gradient-to-r from-transparent to-[#B79A68]" />
            <span className="w-1.5 h-1.5 rotate-45 bg-[#B79A68]" />

            {/* <span className="text-[#7D6A42] text-[10px] uppercase tracking-[0.4em]"></span> */}
            <span className="h-px w-12 bg-gradient-to-l from-transparent to-[#B79A68]" />
          </div>
          <p className="text-[#4E5750]/80 leading-relaxed text-sm md:text-base">
            A clearer view of treatments, from complete smile transformations to biologic and restorative care.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-7">
          {SERVICES.map((s) => (
            <ServiceCard key={s.slug} service={s} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default DentalServicesSection;
